<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { BaseIcon } from '@magma-app/magma-lapilli';
const { locale } = useI18n();
defineProps<{ name: string; comment?: string | null }>();
</script>

<template>
  <figure
    class="m-0 flex gap-3 rounded-lg bg-background-success-default p-4"
    data-cy="relation-positive-feedback"
  >
    <BaseIcon
      icon="check-circle"
      class="shrink-0"
      color="var(--color-foreground-success-default)"
    />
    <div class="min-w-0 text-mgm-txt-sm text-foreground-default">
      <figcaption class="font-medium">
        {{
          $t(
            locale === 'fr' && /^[aeiouyhàâéèêëîïôùûüœ]/i.test(name)
              ? 'helperRelation.feedback.titleVowel'
              : 'helperRelation.feedback.title',
            { name }
          )
        }}
      </figcaption>
      <blockquote
        v-if="comment?.trim()"
        class="m-0 mt-2 whitespace-pre-wrap break-words"
      >
        {{ comment }}
      </blockquote>
      <p v-else class="mt-2">{{ $t('helperRelation.feedback.positive') }}</p>
    </div>
  </figure>
</template>
